import VueI18n from "vue-i18n";

export default function() {
  return new VueI18n({
    locale: "de",
    messages: {
      en: {
        message: {
          noData: "no data",
          clearAllData: "Clear settings",
          category: "Category",
          period: "Period",
          today: "Today",
          tomorrow: "Tomorrow",
          weekend: "Weekend",
          allDates: "Reset",
          dateFormat: "{1}/{0}/{2}",
          cue: "Cue",
          findEvent: "Find event"
        }
      },
      de: {
        message: {
          noData: "Keine Daten",
          clearAllData: "Angaben löschen",
          category: "Kategorie",
          period: "Zeitraum",
          today: "Heute",
          tomorrow: "Morgen",
          weekend: "Wochenende",
          allDates: "Alle Termine",
          dateFormat: "{0}.{1}.{2}",
          cue: "Stichwort",
          findEvent: "Veranstaltung finden"
        }
      }
    }
  });
}
